module.exports = __webpack_public_path__ + "img/pdea.2430f30e.jpg";